'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAccessibilityManageFocus = require('@bibliocommons/base-accessibility-manage-focus');

var _baseAccessibilityManageFocus2 = _interopRequireDefault(_baseAccessibilityManageFocus);

var _tabContent = require('../../tab-content');

var _tabContent2 = _interopRequireDefault(_tabContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tabs = exports.Tabs = function (_BcReactComponent) {
  _inherits(Tabs, _BcReactComponent);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _this.state = {
      activeKey: props.defaultActiveKey,
      children: _react2.default.Children.toArray(_this.props.children)
    };
    _this.bindAll('renderTab', 'renderTabs', 'renderTabContent', 'handleTabClick');
    return _this;
  }

  _createClass(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultActiveKey !== this.props.defaultActiveKey) {
        this.setState({ activeKey: nextProps.defaultActiveKey });
      }
      if (nextProps.children !== this.props.children) {
        this.setState({ children: _react2.default.Children.toArray(nextProps.children) });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.activeKey !== this.state.activeKey) {
        this.focusOnTabContent();
      }
    }
  }, {
    key: 'focusOnTabContent',
    value: function focusOnTabContent() {
      this.props.restoreFocus();
      this.props.captureFocus(this._tabContentContainer, false);
    }
  }, {
    key: 'handleTabClick',
    value: function handleTabClick(e, targetKey) {
      e.preventDefault();

      if (targetKey === this.state.activeKey) {
        this.focusOnTabContent();
      }

      this.setState({ activeKey: targetKey });
    }
  }, {
    key: 'childIsActive',
    value: function childIsActive(child) {
      var activeKey = this.state.activeKey;


      if (!activeKey || !child.props.eventKey) {
        return false;
      }

      return activeKey.toString() === child.props.eventKey.toString();
    }
  }, {
    key: 'renderTab',
    value: function renderTab(child, index) {
      var _this2 = this;

      if (child.type.name === _tabContent2.default.name) {
        var tabClass = this.childIsActive(child) ? 'active' : '';
        return _react2.default.createElement(
          'li',
          { className: tabClass, key: index },
          _react2.default.createElement(
            'a',
            {
              href: '#' + (child.props.tabHref ? child.props.tabHref : child.props.label),
              'data-index': index,
              'data-test-id': child.props.testId,
              onClick: function onClick(e) {
                return _this2.handleTabClick(e, index);
              } },
            child.props.label
          )
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs() {
      var children = this.state.children;

      if (children.length > 1) {
        return _react2.default.createElement(
          'ul',
          { className: 'nav nav-tabs' },
          _lodash2.default.map(children, this.renderTab)
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'renderTabContent',
    value: function renderTabContent() {
      var children = this.state.children;

      if (children.length === 1) {
        return _react2.default.createElement(
          'span',
          null,
          children
        );
      }
      return this.props.children[this.state.activeKey];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'cp-tabs' },
        this.renderTabs(),
        _react2.default.createElement(
          'div',
          { className: 'tab-content', ref: function ref(el) {
              return _this3._tabContentContainer = el;
            } },
          this.renderTabContent()
        )
      );
    }
  }]);

  return Tabs;
}(_baseBcReactComponent2.default);

Tabs.propTypes = {
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react2.default.PropTypes.node), _react.PropTypes.node]).isRequired,
  defaultActive: _react.PropTypes.number,

  // injected by manageFocus
  captureFocus: _react.PropTypes.func.isRequired,
  restoreFocus: _react.PropTypes.func.isRequired
};

exports.default = (0, _reactIntl.injectIntl)((0, _baseAccessibilityManageFocus2.default)(Tabs));


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-tabs/lib/components/tabs/components/Tabs.component.js
// module id = 1197
// module chunks = 0